import React, { useState } from 'react';
import appropriationsService from '../../services/appropriation';
import loaderIcon from '../../assets/loader.svg';
import PrimaryButton from '../../components/Layout/PrimaryButton';
import editIcon from '../../assets/edit-icon.png';

import ModalAppropriations from '../../components/ModalAppropriations';

import './Appropriations.scss';

const Appropriations = () => {
  const initialFields = {
    name: { value: '', valid: true, validationMessage: '' },
    isActive: { value: true, valid: true, validationMessage: '' },
    comments: { value: '', valid: true, validationMessage: '' },
  };

  const [fields, setFields] = useState({ ...initialFields });
  const [loader, setLoader] = useState(false);
  const [backendError, setBackendError] = useState('');
  const [successForm, setSuccessForm] = useState(false);
  const [appropriationsList, setAppropriationsList] = useState(false);
  const [editAppropriation, setEditAppropriation] = useState(false);

  const handleInputChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    setFields((prevFields) => ({
      ...prevFields,
      [name]: {
        ...prevFields[name],
        value: value,
      },
    }));
  };

  const saveAppropriation = async (appropriationData) => {
    try {
      if (!editAppropriation) {
        await appropriationsService.createAppropriation(appropriationData);
      } else {
        await appropriationsService.updateAppropriation(appropriationData.appropriationID, appropriationData);
      }
      setSuccessForm(true);
      setBackendError('');
    } catch (error) {
      console.error('Error fetching expenses:', error);
      setBackendError('Algo deu errado! Tente novamente.');
    } finally {
      setLoader(false);
    }
  };

  const handleCloseModal = (e) => {
    setAppropriationsList(false);
  }

  const handleAppropriationChange = async (data) => {
    console.log(data)
    setFields((prevFields) => ({
      comments: {
        ...prevFields['comments'],
        value: data.comments,
      },
      name: {
        ...prevFields['name'],
        value: data.name,
      },
      appropriationID: {
        ...prevFields['appropriationID'],
        value: data.appropriationID,
      },
      isActive: {
        ...prevFields['isActive'],
        value: !data.isActive ? false : true,
      }
    }));
    setAppropriationsList(false);
    setEditAppropriation(true);
  }

  const validateAppropriationName = (name) => {
    return name.trim() !== '';
  };

  const validateForm = () => {
    // Validation for Razão Social and CNPJ
    const isNameValid = validateAppropriationName(fields.name.value);

    setFields((prevFields) => ({
      ...prevFields,
      ['name']: {
        ...prevFields['name'],
        valid: fields.name.value.length > 2,
      },
    }));

    if (!isNameValid) {
      setLoader(false);
      return false;
    } else {
      setBackendError('');
    }

    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoader(true);
    const formData = {};
    Object.entries(fields).forEach(([fieldName, fieldData]) => {
      formData[fieldName] = fieldData.value;
    });

    try {
      await saveAppropriation(formData);
      setSuccessForm(true);
    } catch (error) {
      console.error('Error saving companie:', error);
      setBackendError('Algo deu errado! Tente novamente.');
    } finally {
      setLoader(false);
    }
  };

  const resetForm = () => {
    setFields({ ...initialFields });
    setLoader(false);
    setBackendError('');
    setSuccessForm(false);
    setEditAppropriation(false);
  };

  return (
    <>
      {appropriationsList && (
        <ModalAppropriations onCloseModal={handleCloseModal} appropriationData={handleAppropriationChange} />
      )}

      <div className='appropriations-screen wrapper-content form-box'>
        {!backendError && !successForm && (
          <>
            {editAppropriation && (
              <button className="back-button" onClick={(e) => { e.preventDefault(); setLoader(true); window.location.reload(); }} style={{ background: 'none', border: 'none', cursor: 'pointer', position: 'absolute', left: 10, top: 15 }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            )}
            <h2>{!editAppropriation ? 'Cadastro de Apropriação' : 'Editar Apropriação'}</h2>
            <button className='editSup' onClick={() => setAppropriationsList(true)}><img src={editIcon} alt="Edit icon" style={{ width: '18px', height: '18px' }} /></button>
          </>
        )}

        {backendError && (
          <>
            <h2 className="error-message">
              {backendError}
            </h2>
            <PrimaryButton fullWidth onClick={resetForm}>
              Voltar
            </PrimaryButton>
          </>
        )}

        {!backendError && successForm && (
          <div style={{ width: '60%', margin: '0 auto' }}>
            <h2>{!editAppropriation ? 'Cadastro realizado no sistema!' : 'Edição realizada com sucesso!'}</h2>
            <PrimaryButton fullWidth onClick={resetForm}>
              Voltar
            </PrimaryButton>
          </div>
        )}

        {loader && !backendError && !successForm ? (
          <img src={loaderIcon} alt="Carregando..." width={100} height={100} />
        ) : (
          !successForm && (
            <form onSubmit={handleSubmit} className="appropriations-screen__form" action="#">
              <label>
                Nome<sup>*</sup>
                <input
                  type="text"
                  name='name'
                  className={fields.name.valid === false ? 'has-error' : ''}
                  onChange={handleInputChange}
                  defaultValue={fields.name.value}
                  tabIndex={1}
                  onBlur={(e) => {
                    validateForm();
                  }}
                />
              </label>
              
              <label>
                Ativo<sup></sup>
                <input
                  align="left"
                  type="checkbox"
                  name="isActive"
                  checked={fields.isActive.value}
                  onChange={handleInputChange}
                  tabIndex={2}
                />
              </label>
              <label>
                Observação
                <textarea
                  name='comments'
                  onChange={handleInputChange}
                  defaultValue={fields.comments.value}
                  tabIndex={6}
                />
              </label>
              <input className={'btn--primary'} type='submit' value={!editAppropriation ? "Salvar" : "Salvar Edição"} tabIndex={7} />
            </form>
          )
        )}
      </div>
    </>
  );
};

export default Appropriations;
